/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Dates_Todayformatted1Inputs */

const en_dates_todayformatted1 = /** @type {(inputs: Dates_Todayformatted1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Today at ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Today at {date}" |
*
* @param {Dates_Todayformatted1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const dates_todayformatted1 = /** @type {((inputs: Dates_Todayformatted1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dates_Todayformatted1Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_dates_todayformatted1(inputs)
});
export { dates_todayformatted1 as "dates_todayFormatted" }